import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { PrinciplesList } from '../ui/PrinciplesList';
import { Reveal } from '../motion/Reveal';
import { principles } from '../../data/approach';
export function HomeApproach() {
  return <section id="approach" className="scroll-mt-20 bg-white" aria-labelledby="approach-title" data-id="element-142" data-mp="2s2j0u47pneto">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-143" data-mp="2x02gn8k23znq">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-144" data-mp="3kqev729t4una">
          <SectionHeading id="approach-title" eyebrow="Our Approach" title="People Shape the Future of Every Organization." className="lg:col-span-5" data-id="element-145" data-mp="3pogf1pf24xzt" />
          <Reveal className="space-y-6 text-[17px] leading-relaxed text-ink lg:col-span-6 lg:col-start-7 lg:pt-10" data-id="element-146" data-mp="3fq0q9t3i60th">
            <p data-id="element-147" data-mp="209aap3qu7nzo">
              The right appointment can change the direction of an organization. We make senior hiring decisions more
              considered — grounded in research, informed by the market and handled with the discretion that
              leadership moves require.
            </p>
            <blockquote className="border-l-2 border-gold pl-6" data-id="element-148" data-mp="3vjyz1vvhqsr2">
              <p className="font-serif text-[1.65rem] font-medium leading-snug text-navy" data-id="element-149" data-mp="ddkma08ykou9">
                “We help organizations identify, engage, and connect with professionals whose expertise and
                leadership can support long-term success.”
              </p>
            </blockquote>
          </Reveal>
        </div>
        <div className="mt-20" data-id="element-150" data-mp="idfdy60k5igd">
          <PrinciplesList items={principles} columns={4} data-id="element-151" data-mp="ic47fyfq9wlk" />
        </div>
      </div>
    </section>;
}